module.exports = __webpack_public_path__ + "img/pendingValidationStatusIcon.5da88204.svg";